import { useLeaderboards } from "api/leaderboards";
import { useAppSelector } from "app/hooks";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { sortCampaignTranslations } from "components/Layout/Campaign/Common/campaignHelpers";
import { useMessage } from "hooks/intl";
import { useParams } from "react-router-dom";
import { selectDefaultLanguageData } from "reduxState/translations/translationsSlice";
import { links } from "utilities/links";
import LeaderboardForm from "./LeaderboardForm";

export function EditLeaderboard() {
  const { message } = useMessage();
  const { useLeaderboardData } = useLeaderboards();
  const { id: leaderboardID } = useParams<{ id: string }>();
  const { data: leaderboardData } = useLeaderboardData(leaderboardID as string);
  const defaultLang = useAppSelector(selectDefaultLanguageData);

  const initialValues = leaderboardData
    ? {
        ...leaderboardData,
        translations: sortCampaignTranslations(
          defaultLang?.code,
          leaderboardData?.translations || [],
        ),
        trackedMetric: {
          metric: "numberOfActiveUnitsInWallet",
        },
      }
    : undefined;

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "leaderboards" }),
      path: links.leaderboardsList,
    },
  };

  return (
    <>
      <TopHeader
        title={
          leaderboardData
            ? `${message({ id: "editLeaderboard" })} "${leaderboardData?.name}"`
            : ""
        }
        clearLink={links.leaderboardsList}
        breadcrumbs={breadcrumbs}
      />
      <div>
        {leaderboardData && (
          <LeaderboardForm
            initialValues={initialValues}
            isEditMode
            leaderboardId={leaderboardID}
          />
        )}
      </div>
    </>
  );
}
